import type { StringKey } from '@ipfabric/utils';
import classNames from 'classnames';
import type { FormikProps } from 'formik';
import type { JSX } from 'react';
import { fieldHasError } from 'utils/formik/fieldHasError';
import type { NestedFormikName } from 'utils/formik/nestedFormikName';

interface Props<TFormikValues> {
  className?: string;
  formik: FormikProps<TFormikValues>;
  id?: string;
  max?: number;
  min?: number;
  name: StringKey<TFormikValues> | NestedFormikName;
  placeholder?: string;
  disabled?: boolean;
}

export const FormikNumberField = <TFormikValues,>(
  props: Props<TFormikValues>,
): JSX.Element => {
  const field = props.formik.getFieldProps(props.name);
  const hasError = fieldHasError<TFormikValues>(props.formik, props.name);

  return (
    <input
      {...field}
      className={classNames(props.className, hasError && 'formik-field__error')}
      disabled={props.disabled}
      id={props.id}
      max={props.max}
      min={props.min}
      placeholder={props.placeholder}
      type='number'
    />
  );
};
